import { render, staticRenderFns } from "./NavBarVertical.vue?vue&type=template&id=12172820&scoped=true"
import script from "./NavBarVertical.vue?vue&type=script&lang=js"
export * from "./NavBarVertical.vue?vue&type=script&lang=js"
import style0 from "./NavBarVertical.vue?vue&type=style&index=0&id=12172820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12172820",
  null
  
)

export default component.exports